// Generated from ESF schema: metrics
// Do not edit manually!
/** Time window for aggregation */
export var AggregationWindow;
(function (AggregationWindow) {
    AggregationWindow["Realtime"] = "realtime";
    AggregationWindow["Minute"] = "minute";
    AggregationWindow["Hour"] = "hour";
    AggregationWindow["Day"] = "day";
    AggregationWindow["Week"] = "week";
})(AggregationWindow || (AggregationWindow = {}));
/** Type of metric */
export var MetricType;
(function (MetricType) {
    MetricType["Gauge"] = "gauge";
    MetricType["Counter"] = "counter";
    MetricType["Histogram"] = "histogram";
    MetricType["Summary"] = "summary";
})(MetricType || (MetricType = {}));
//# sourceMappingURL=metrics.js.map